import {useRecoilState} from "recoil";
import accessTokenState from "../state/accessTokenState";
import {useEffect} from "react";
import api from "../services/api";
import {toast} from "react-toastify";
import queryClient from "../services/queryClient";

const useSetupAxiosMiddleware = () => {
  const [accessToken, setAccessToken] = useRecoilState(accessTokenState);

  useEffect(() => {
    api.interceptors.response.use(response => {
      // Update global date from server
      if(response?.headers?.date) {
        window.SERVER_DATE = +(new Date(response.headers.date));
      }

      return response;
    }, (error) => {
      // Watch for errors and reset access token if token expired
      if(error.response) {
        if(error.response && (error.response.status === 401 || error.response.status === 419)) {
          setAccessToken(null);
          toast("Oops! Someone is sharing your passcode!", {
            type: 'error',
            autoClose: false,
            toastId: 'sessionExpired'
          })
        }
      }

      return Promise.reject(error);
    });
  }, []);

  useEffect(() => {
    // Refetch data if token expires
    queryClient.resetQueries();
  }, [accessToken]);
}

export default useSetupAxiosMiddleware;
